import { Flex, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
  onNext?: () => void;
  onPrevious?: () => void;
  nextLabel?: string;
  isNextSecondary?: boolean;
  previousLabel?: string;
  complete?: boolean;
}

const PrevNextButtons = (props: IProps) => {
  const { onNext, onPrevious, nextLabel, isNextSecondary, previousLabel, complete } = props;

  return (
    <>
      <Flex gap={{ base: 2, lg: 4 }} mt={8}>
        {onPrevious ? (
          <Button
            onClick={onPrevious}
            leftIcon={<FontAwesomeIcon icon={faChevronLeft} className="utility-icon" />}
            size="lg"
            flexBasis="100%"
            flexGrow="1"
            flexShrink="1"
          >
            {previousLabel || 'Previous'}
          </Button>
        ) : null}
        {onNext ? (
          <Button
            id="save_and_continue"
            onClick={onNext}
            isDisabled={complete ? false : true}
            variant={isNextSecondary ? 'secondary' : 'solid'}
            rightIcon={<FontAwesomeIcon icon={faChevronRight} className="utility-icon" />}
            size="lg"
            flexBasis="100%"
            flexGrow="1"
            flexShrink="1"
          >
            {nextLabel || 'Start'}
          </Button>
        ) : null}
      </Flex>
    </>
  );
};

export default PrevNextButtons;
